import React, { useEffect } from "react";
import { Helmet, HelmetProvider } from "react-helmet-async";
import useProcessToday from "../../../hooks/useProcessToday";

interface TitleUpdaterProps {
  displayTitle?: string;
}

const TitleUpdater = ({ displayTitle }: TitleUpdaterProps) => {
  const { counter_pending_review } = useProcessToday();
  const title = displayTitle ?? `(${counter_pending_review}) - Vistaflow`;

  useEffect(() => {
    document.title = title;
  }, [title]);

  return (
    <HelmetProvider>
      <Helmet>
        <title>{title}</title>
      </Helmet>
    </HelmetProvider>
  );
};

export default TitleUpdater;
